import "./Stats.css";
import "./StatsResponsive.css";

import stats from "../../../assets/data/stats/farm-stats.json";
import StatsItem from "./stats-item/StatsItem";

function Stats() {
  return (
    <div className="row m-0 stats">
      {stats?.stats?.map((stat, index) => (
        <StatsItem
          stat={stat}
          duration={stats?.duration}
          delay={stats?.delay}
          key={index}
        />
      ))}
    </div>
  );
}

export default Stats;
